import {Button,CircularProgress,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import Lang from "../../../components/Lang";
import { useState } from "react";
import SelectFromList from "../../../components/SelectFromList";
import Text from "../../../components/Text";
import VND from "../../../components/VND";
import CheckBox from "../../../components/CheckBox";
import DateChoice from "../../../components/DateChoice";
import SLink from "../../../components/SLink";
import useCTX from "../../../hooks/useCTX";
import mut from "../../../hooks/mut";




export default function NewBillDialog({ open, setOpen, student, setStudent }) {

  const [numberOfLessons, setNumberOfLessons] = useState(40)
  const [customNumberOfLessons, setCustomNumberOfLessons] = useState("");
  const [sending,setSending] = useState(false)

  const [costPerLesson, setCostPerLesson] = useState(100000);
  const [customCostPerLesson, setCustomCostPerLesson] = useState("");

  const [booksAmount, setBooksAmount] = useState(100000);
  const [customBooksAmount, setCustomBooksAmount] = useState("");
  const [hasBooks, setHasBooks] = useState(false);
  const [booksDescription,setBooksDescription] = useState("")

  const [scholarshipAmount, setScholarshipAmount] = useState(100000);
  const [customScholarshipAmount, setCustomScholarshipAmount] = useState("");
  const [hasScholarship, setHasScholarship] = useState(false)
  const [scholarshipDescription, setScholarshipDescription] = useState("");

  const [discount, setDiscount] = useState(50000);
  const [customDiscount, setCustomDiscount] = useState("");
  const [hasDiscount, setHasDiscount] = useState(false);
  const [discountDescription, setDiscountDescription] = useState("");

  const { findClasses } = useCTX();
  const classes = findClasses(student.classes);

  const [htClass, setHtClass] = useState(classes.length>0 ? classes[0]._id : "")
  const [startDate, setStartDate] = useState(undefined)
  const { findClass } = useCTX();
  const htc = findClass(htClass);
  const description = `${
    numberOfLessons !== 123456789 ? numberOfLessons : customNumberOfLessons
  } buổi lớp ${htc.name}, Từ ngày: ${new Date(startDate).fDate()}`;


  const addBills = async () => {
   
    let costPerLessonReal = costPerLesson === 123456789 ? customCostPerLesson : costPerLesson
    
    if (hasScholarship) {
      let sc = scholarshipAmount!==123456789 ? scholarshipAmount : customScholarshipAmount
      costPerLessonReal -= Math.round(sc / numberOfLessons)
    }
    if (hasDiscount) {
         let dc =
           discount !== 123456789
             ? discount
             : customDiscount;
       costPerLessonReal -= Math.round(dc/ numberOfLessons);
     }
   
    const body = [{
      billType: "Tuition",
      amount: (numberOfLessons===123456789 ? customNumberOfLessons : numberOfLessons) * (costPerLesson===123456789? customCostPerLesson : costPerLesson),
      description,
      classId: htClass,
      loca: htc.managedBy,
      location: [htc.managedBy],
      firstClassDate: startDate,
      numberOfLessons:numberOfLessons===123456789 ? customNumberOfLessons : numberOfLessons,
      costPerLesson:costPerLesson===123456789? customCostPerLesson : costPerLesson,
      costPerLessonReal
    }]

    if (hasBooks) {
      const bill = {
        billType: "Books",
        amount: booksAmount !== 123456789 ? booksAmount : customBooksAmount,
        description: booksDescription,
        classId: htClass,
        loca: htc.managedBy,
        location: [htc.managedBy]
      }
      body.push(bill)
    }

     if (hasScholarship) {
       const bill = {
         billType: "Scholarship",
         amount: scholarshipAmount !== 123456789 ? 0-scholarshipAmount : 0-customScholarshipAmount,
         description: scholarshipDescription,
         classId: htClass,
         loca: htc.managedBy,
         location: [htc.managedBy],
       };
       body.push(bill);
     }
    
     if (hasDiscount) {
       const bill = {
         billType: "Discount",
         amount:
           discount !== 123456789
             ? 0-discount
             : 0-customDiscount,
         description: discountDescription,
         classId: htClass,
         loca: htc.managedBy,
         location: [htc.managedBy],
       };
       body.push(bill);
     }

      setSending(true);
    let res = await mut("post", `/student/${student._id}/bills/add`, body)
    if (res) {
      setStudent(prev=>({...prev, unpaidBills:res}))
      setOpen(false)
      setSending(false)
    }
    setSending(false)
  }

  const disabled = checkDisabled(
    htClass,
    startDate,
    numberOfLessons !== 123456789 ? numberOfLessons : customNumberOfLessons,
    costPerLesson !== 123456789 ? costPerLesson : customCostPerLesson,
    hasBooks,
    booksAmount !== 123456789 ? booksAmount : customBooksAmount,
    booksDescription,
    hasScholarship,
    scholarshipAmount !== 123456789 ? scholarshipAmount : customScholarshipAmount,
    scholarshipDescription,
    hasDiscount,
    discount!== 123456789 ? discount : customDiscount,
    discountDescription,
    sending
  );

 
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={"lg"}
    >
      <DialogTitle>
        <div className="flex justify-between">
          <div>
            <Lang w="addTuitionFees" />
          </div>
          <div>
            <SLink
              id={student._id}
              noLink
            />
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        {sending ? (
          <div className="h-100 flex items-center justify-center">
            <div className="flex flex-col justify-center items-center gap-4">
              <div>Sending bills</div>
              <div>
                <CircularProgress />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-1">
            <div className="flex items-stretch">
              <div className="flex-1 flex flex-col gap-2">
                <ClassAndDate
                  htClass={htClass}
                  setHtClass={setHtClass}
                  classes={classes}
                  startDate={startDate}
                  setStartDate={setStartDate}
                />
                <Numbers
                  value={numberOfLessons}
                  setValue={setNumberOfLessons}
                  custom={customNumberOfLessons}
                  setCustom={setCustomNumberOfLessons}
                  label="numberOfLessons"
                  choices={lessonsNumbers}
                />
                <Numbers
                  value={costPerLesson}
                  setValue={setCostPerLesson}
                  custom={customCostPerLesson}
                  setCustom={setCustomCostPerLesson}
                  label="feePerLesson"
                  choices={costChoices}
                  vnd
                />
              </div>
              <Receipt
                numberOfLessons={
                  numberOfLessons !== 123456789
                    ? numberOfLessons
                    : customNumberOfLessons
                }
                costPerLesson={
                  costPerLesson !== 123456789
                    ? costPerLesson
                    : customCostPerLesson
                }
                description={description}
                hasBooks={hasBooks}
                bookAmount={
                  booksAmount !== 123456789 ? booksAmount : customBooksAmount
                }
                bookDescription={booksDescription}
                hasScholarship={hasScholarship}
                scholarshipAmount={
                  scholarshipAmount !== 123456789
                    ? scholarshipAmount
                    : customScholarshipAmount
                }
                scholarshipDescription={scholarshipDescription}
                hasDiscount={hasDiscount}
                discountAmount={
                  discount !== 123456789 ? discount : customDiscount
                }
                discountDescription={discountDescription}
                htClass={htClass}
                startDate={startDate}
              />
            </div>

            <Extras
              value={booksAmount}
              setValue={setBooksAmount}
              custom={customBooksAmount}
              setCustom={setCustomBooksAmount}
              enable={hasBooks}
              setEnable={setHasBooks}
              label="Books"
              choices={bookChoices}
              description={booksDescription}
              setDescription={setBooksDescription}
            />
            <Extras
              value={scholarshipAmount}
              setValue={setScholarshipAmount}
              custom={customScholarshipAmount}
              setCustom={setCustomScholarshipAmount}
              enable={hasScholarship}
              setEnable={setHasScholarship}
              label="Scholarship"
              choices={scholarshipChoices}
              description={scholarshipDescription}
              setDescription={setScholarshipDescription}
            />
            <Extras
              value={discount}
              setValue={setDiscount}
              custom={customDiscount}
              setCustom={setCustomDiscount}
              enable={hasDiscount}
              setEnable={setHasDiscount}
              label="Discount"
              choices={discountChoices}
              description={discountDescription}
              setDescription={setDiscountDescription}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button
          color="success"
          disabled={disabled}
          onClick={addBills}
        >
          Go
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function ClassAndDate({ htClass, setHtClass, startDate, setStartDate, classes, noClass }) {
  const { classDays } = useCTX()
  return (
 
      <div className="flex gap-3 mt-2">
        <SelectFromList
          value={htClass}
          setValue={setHtClass}
          choices={classes}
          size="small"
          label="Class"
          style={{ width: 200 }}
          disabled={noClass}
        />
        <DateChoice
          value={startDate}
          setValue={setStartDate}
          label={<Lang w={"firstLesson"}/>}
          width={200}
          enabledDays={classDays(htClass)}
          error={!startDate}
        />
      </div>

  );
}

function Extras({ enable, setEnable, value, setValue, custom, setCustom, description, setDescription, label, choices }) {

  return (
    <div className="p-2 rounded mt-1 mb-1 border-gray-300 border">
      <div
        className="flex mb-1"
        style={{ alignItems: "center" }}
      >
        <div
          className="flex w-51"
          style={{ alignItems: "center" }}
        >
          <CheckBox
            value={enable}
            setValue={setEnable}
          />{" "}
          <div className="text-sm">{label}</div>
        </div>
        {enable && (
          <div>
            <Numbers
              value={value}
              setValue={setValue}
              custom={custom}
              setCustom={setCustom}
              choices={choices}
              label="amount"
              vnd
            />
          </div>
        )}
      </div>
      {enable && (
        <div>
          <Text
            value={description}
            setValue={setDescription}
            size="small"
            label="Description"
            fullWidth
         
          />
        </div>
      )}
    </div>
  );
}

function Receipt({
  numberOfLessons,
  costPerLesson,
  hasBooks,
  bookAmount = 0,
  bookDescription,
  hasScholarship,
  scholarshipAmount = 0,
  scholarshipDescription,
  hasDiscount,
  discountAmount = 0,
  discountDescription,
  description,
  startDate
}) {

let amount = numberOfLessons * costPerLesson
  if (hasBooks) amount += bookAmount
  if (hasScholarship) amount -= scholarshipAmount
  if (hasDiscount) amount -= discountAmount

  return (
    <div className="flex-1 h-38 flex flex-col border rounded p-2 bg-gray-200 text-sm ">
      <div className="flex flex-col h-full justify-between">
        <div>
          {(numberOfLessons && costPerLesson && startDate) && <LineItem
            description={description}
            amount={numberOfLessons * costPerLesson}
          />}
          {(hasBooks && bookAmount && bookDescription) &&(
            <LineItem
              description={bookDescription}
              amount={bookAmount}
            />
          )}
          {(hasScholarship && scholarshipAmount && scholarshipDescription) && (
            <LineItem
              description={scholarshipDescription}
              amount={scholarshipAmount}
              negative
            />
          )}
          {(hasDiscount && scholarshipAmount && scholarshipDescription) && (
            <LineItem
              description={discountDescription}
              amount={discountAmount}
              negative
            />
          )}
        </div>

        <div className="font-bold pt-2 border-t border-gray-400 mt-2">
          {(numberOfLessons && costPerLesson && startDate) && <LineItem
            description={<Lang w="total" />}
            amount={amount}
          />}
        </div>
      </div>
    </div>
  );
}

function checkDisabled(htClass, startDate, numberOfLessons, costPerLesson, hasBooks, booksAmount, booksDescription, hasScholarship, scholarshipAmount, scholarshipDescription, hasDiscount, discount, discountDescription, sending) {
  if(sending) return true
  if (!htClass || !startDate || !numberOfLessons || !costPerLesson) return true
  if (hasBooks) {
    if(!booksAmount || !booksDescription) return true
  }
  if (hasScholarship) {
    if(!scholarshipAmount || !scholarshipDescription) return true
  }
  if (hasDiscount) {
     if (!discount|| !discountDescription) return true;
  }
  return false
}


function LineItem({ description, amount, negative }) {
  
  return (
    <div className="flex justify-between">
      <div className="">
      {description}
      </div>
      <div className="">{<VND value={negative ? 0-amount : amount} />}</div>
    </div>
  );
}

function Numbers({ value, setValue, custom, setCustom, label, choices, vnd=false }) {
  
  return (
    <div className="mb-1 mt-1 flex gap-3">
      <SelectFromList
        value={value}
        setValue={setValue}
        choices={choices}
        size="small"
        className="w-50"
        label={<Lang w={label} />}
      />

      {value === 123456789 && (
        vnd ? <VND value={custom}
          setValue={setCustom}
          size="small"
          label={<Lang w="otherAmount" />}
          error={!custom}
          />
          : <Text
            value={custom}
            setValue={setCustom}
            type="number"
            size="small"
            align="right"
            label={<Lang w="otherAmount" />}
            error={!custom}
        />
      )}
    </div>
  );
}

const lessonsNumbers = [
  {
    _id: 10,
    name: "10 lessons",
  },
  {
    _id: 20,
    name: "20 lessons",
  },
  {
    _id: 24,
    name: "24 lessons",
  },
  {
    _id: 32,
    name: "32 lessons",
  },
  {
    _id: 40,
    name: "40 lessons",
  },
  {
    _id: 80,
    name: "80 lessons",
  },
  { _id: 123456789, name: "Other amount" },
];

const costChoices = [
  {
    _id: 100000,
    name: "100,000 per lesson",
  },
  {
    _id: 120000,
    name: "120,000 per lesson",
  },
  {
    _id: 130000,
    name: "130,000 per lesson",
  },
  {
    _id: 150000,
    name: "150,000 per lesson",
  },
  {
    _id: 170000,
    name: "170,000 per lesson",
  },
  {
    _id: 185000,
    name: "185,000 per lesson",
  },
  {
    _id: 200000,
    name: "200,000 per lesson",
  },
  {
    _id: 220000,
    name: "220,000 per lesson",
  },
  {
    _id: 123456789,
    name: "Other price",
  },
];

const scholarshipChoices = [
  {
    _id: 100000,
    name: "100,000",
  },
  {
    _id: 200000,
    name: "200,000",
  },
  {
    _id: 500000,
    name: "500,000",
  },
  {
    _id: 123456789,
    name: "Other amount",
  },
];

const discountChoices = [
  {
    _id: 50000,
    name: "50,000",
  },
  {
    _id: 100000,
    name: "100,000",
  },
  {
    _id: 200000,
    name: "200,000",
  },
  {
    _id: 300000,
    name: "300,000",
  },
  {
    _id: 400000,
    name: "400,000",
  },
  {
    _id: 500000,
    name: "500,000",
  },
  {
    _id: 123456789,
    name: "Other amount",
  },
];

const bookChoices = [
  {
    _id: 50000,
    name: "50,000",
  },
  {
    _id: 100000,
    name: "100,000",
  },
  {
    _id: 150000,
    name: "150,000",
  },
  {
    _id: 200000,
    name: "200,000",
  },
  {
    _id: 250000,
    name: "250,000",
  },
  {
    _id: 300000,
    name: "300,000",
  },
  {
    _id: 123456789,
    name: "Other amount",
  },
];